import assetPath from '/opt/actions-runner/_work/crate/crate/packages/dream-machine/search-bar/src/components/assets/Background_04_1x1_a.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')